import React from 'react';
import { getWindowObject } from '@eventbrite/feature-detection';
import { translationPropType } from '@eventbrite/i18n';

export default class PageTitle extends React.PureComponent {
    static propTypes = {
        title: translationPropType.isRequired,
    };

    componentDidMount() {
        this.updateTitle();
    }

    componentDidUpdate() {
        this.updateTitle();
    }

    updateTitle = () => {
        const document = getWindowObject('document');

        if (document) {
            document.title = this.props.title;
        }
    };

    render() {
        return null;
    }
}
